<template>
  <div class="absolute top-0 left-1/2 -translate-x-1/2 max-w-2xl w-full h-full py-4">
    <div class="overflow-hidden h-full w-full rounded-2xl">
      <div class="bg-base-100 overflow-auto h-full w-full">
        <div
          v-for="pin in filteredPins"
          :key="pin._id"
          class="transition-colors hover:bg-base-200"
          @click="$emit('select', pin)"
        >
          <div class="p-4">
            <h1 class="text-accent text-center text-2xl mb-4">
              {{ pin.title }}
            </h1>
            <p class="line-clamp-3">
              {{ pin.description }}
            </p>
          </div>
          <div class="divider !mt-0 !mb-0 !h-[2px]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePinsStore } from '@/stores/pins'
import { storeToRefs } from 'pinia'

import type { Pin } from '@/interfaces'

const pinsStore = usePinsStore()
const { filteredPins } = storeToRefs(pinsStore)

defineEmits<{
  (e: 'select', value: Pin): void
}>()
</script>
